<template>
  <el-dialog
    :title="$t('businessOpportunityManageMessages.delete.title')"
    :visible.sync="visible"
    width="40%"
    @close="handleClose"
  >
    <div class="delete-content">
      <i class="el-icon-warning-outline warning-icon"></i>
      <p>{{ $t("businessOpportunityManageMessages.delete.confirmText") }}</p>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">
        {{ $t("common.cancel") }}
      </el-button>
      <el-button type="danger" @click="confirmDelete">
        {{ $t("common.confirmDelete") }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteBusinessOpportunity } from "@/api/businessOpportunity/businessOpportunityApi";

export default {
  name: "DeleteBusinessOpportunity",
  data() {
    return {
      visible: false,
      form: {
        id: "",
        opportunityName: "",
        customerName: "",
      },
    };
  },
  methods: {
    // 接收商机数据打开弹窗
    open(opportunityData) {
      this.visible = true;
      this.form = {
        id: opportunityData.id,
      };
    },

    // 确认删除
    async confirmDelete() {
      try {
        const response = await deleteBusinessOpportunity(this.form);
        if (response.code === 0) {
          this.$message.success("商机删除成功");
          this.visible = false;
          this.$emit("success");
        } else {
          this.$message.error(response.msg || "商机删除失败");
        }
      } catch (error) {
        this.$message.error("操作失败");
        console.error("删除商机失败:", error);
      }
    },

    // 关闭弹窗重置
    handleClose() {
      this.form = {
        id: "",
        opportunityName: "",
        customerName: "",
      };
      this.resetForm();
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-content {
  padding: 20px 0;
  text-align: center;

  .warning-icon {
    font-size: 24px;
    color: #e6a23c;
    margin-bottom: 16px;
  }

  p {
    color: #606266;
    font-size: 14px;
    margin-bottom: 8px;
  }

  .detail-info {
    color: #909399;
    font-size: 13px;
  }
}

.dialog-footer {
  display: flex;
  justify-content: center;
  padding: 12px 24px 24px;
}
</style>
